module.exports = __webpack_public_path__ + "img/hk-bottom.68c50024.png";